module.exports = __webpack_public_path__ + "static/media/9.27d35182.png";